<template>
    <div v-if="mostrar" class="modal-mask" @click.self="$emit('fechar')">
        <div class="jm" style="height: max-content; width: 36rem; padding: 1rem 2rem; border-radius: 5px;" @click.stop>
            <div>
                <h3>Excluir tarefa?</h3>
            </div>
            <hr>
            <div style="margin-top: 1rem; line-height: 1.5;">
                <template v-if="quantidadeVinculos > 0">
                    <p>
                        <strong>{{ codigoTarefa }}</strong> possui
                        <strong>{{ quantidadeVinculos }}</strong>
                        {{ quantidadeVinculos === 1 ? 'tarefa vinculada' : 'tarefas vinculadas' }}.
                    </p>
                    <p>
                        Ao confirmar, <strong>esta e todas as tarefas vinculadas serão excluídas permanentemente</strong>.
                        Deseja continuar?
                    </p>
                </template>
                <p v-else>
                    Tem certeza de que deseja excluir a tarefa <strong>{{ codigoTarefa }}</strong>?
                </p>
            </div>
            <div class="submit direita" style="gap: 0.5rem;">
                <button class="acao-secundaria" :disabled="excluindo" type="button" @click="$emit('fechar')">
                    Cancelar
                </button>
                <button class="button txt-erro" style="background-color: var(--cor-erro); color: #fff;"
                    :disabled="excluindo" type="button" @click="$emit('confirmar')">
                    {{ excluindo ? 'Excluindo…' : 'Sim, excluir' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalConfirmarExclusaoTarefa',
    props: {
        mostrar: { type: Boolean, default: false },
        codigoTarefa: { type: String, default: '' },
        quantidadeVinculos: { type: Number, default: 0 },
        excluindo: { type: Boolean, default: false },
    },
    emits: ['fechar', 'confirmar'],
};
</script>
